import type { ApiNodeDataAction, EntityStatusOption } from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';
import type { BaseNodeButtonColor } from '../../components/node-icon';

export const getActionIconColor = (data: ApiNodeDataAction): BaseNodeButtonColor => {
  const { setDecision, raiseManualReview } = data;
  if (setDecision === 'pass') return 'success';
  if (raiseManualReview) return 'warning';
  if (setDecision === 'fail') return 'error';
  return 'primary';
};

export const getActionSubtitle = (
  data: ApiNodeDataAction,
  t: TFunction<'playbook-builder'>,
  statuses?: EntityStatusOption[],
): string => {
  const { setDecision, raiseManualReview, addTags = [], addAnnotations = [], setEntityStatuses = [] } = data;
  const actions: string[] = [];

  if (setDecision === 'pass') {
    actions.push(t($ => $.actionTitle.pass));
  } else if (setDecision === 'fail') {
    actions.push(t($ => $.actionTitle.fail));
  } else if (setDecision === 'none') {
    actions.push(t($ => $.actionTitle.none));
  }

  if (raiseManualReview) {
    actions.push(t($ => $.actionTitle.raiseManualReview));
  }

  if (addTags.length > 0) {
    actions.push(t($ => $.actionTitle.addTag));
  }

  if (addAnnotations.length > 0) {
    actions.push(t($ => $.actionTitle.addNote));
  }

  setEntityStatuses.forEach(status => {
    const statusOption = statuses?.find(s => s.id === status.statusId);
    if (statusOption) {
      actions.push(
        `${statusOption.displayName} ${statusOption.entries.find(e => e.id === status.entryId)?.displayName}`,
      );
    }
  });

  return actions.join(', ');
};
